import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Wrapper from '../../components/wrapper'
import { convertPipeToBrTag, convertKataToRome } from '../../utils'
import { WINDOW, IS_MOBILE } from '../../constants/environment'
import CarLineupFilter from '../car-lineup-filter'
import './styles.css'
import BodyControl from '../../components/body'

/**
 *  CarLineup
 */
class CarLineup extends PureComponent {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    narrowPassengerCarCategory: PropTypes.bool,
    passengerCarFilters: PropTypes.array,
    models: PropTypes.arrayOf(PropTypes.shape({
      modelName: PropTypes.string,
      modelNameJa: PropTypes.string,
      vehicleType: PropTypes.string,
      vehicleTabName: PropTypes.string,
      bodyTypes: PropTypes.arrayOf(PropTypes.shape({
        carTypeCode: PropTypes.string,
        carId: PropTypes.string,
        bodyTypeModel: PropTypes.string,
        bodyTypeCategory: PropTypes.string,
        fuels: PropTypes.array,
        fuelTabNames: PropTypes.array,
        drives: PropTypes.array,
        transmissions: PropTypes.array,
        minPrice: PropTypes.number,
        maxPrice: PropTypes.number,
        specSummary: PropTypes.shape({
          minWLTC: PropTypes.string,
          maxWLTC: PropTypes.string,
          minJC08: PropTypes.string,
          maxJC08: PropTypes.string,
          passengers: PropTypes.array,
          minDisplacement: PropTypes.string,
          maxDisplacement: PropTypes.string,
          minLength: PropTypes.string,
          maxLength: PropTypes.string,
          minWidth: PropTypes.string,
          maxWidth: PropTypes.string,
          minHeight: PropTypes.string,
          maxHeight: PropTypes.string
        }),
        acquisitionTaxRate: PropTypes.number,
        weightTaxRate: PropTypes.number,
        taxCut: PropTypes.number,
        subsidy: PropTypes.bool,
        supportCar: PropTypes.array,
        grades: PropTypes.arrayOf(PropTypes.shape({
          specialCar: PropTypes.bool,
          specialCarTabName: PropTypes.string,
          welfareCar: PropTypes.bool,
          welfareCarTabName: PropTypes.string,
          welfareCarTypeCategory: PropTypes.string,
          gradeId: PropTypes.string,
          gradeName: PropTypes.string,
          specialCarDefaultGrade: PropTypes.bool,
          welfareCarDefaultGrade: PropTypes.bool,
          carLineupUrl: PropTypes.string,
          minPrice: PropTypes.number
        }))
      }))
    }))
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    narrowPassengerCarCategory: null,
    passengerCarFilters: null,
    models: null
  };

  constructor(props) {
    super()
    this.props = props
    this.state = {
      vehicle: 'Passenger Car',
      view: this.props.narrowPassengerCarCategory ? 'List' : 'Grid', // Grid or List
      models: null
    }
    this.tmpState = {
      vehicle: this.state.vehicle,
      view: this.state.view,
      filter: {}
    }
    this.onChangeVehicle = this.onChangeVehicle.bind(this)
    this.onChangeFilter = this.onChangeFilter.bind(this)
    this.onResetFilter = this.onResetFilter.bind(this)

    this.vehicleIntervalId
  }

  componentWillUnmount() {
  }

  componentDidMount() {
    if (this.refs.filter) {
      const radios = this.refs.filter.querySelectorAll("input[type='radio']")
      for (let i = 0; i < radios.length; i++) {
        const label = radios[i].parentNode
        label.onclick = this.onClickRadio
        radios[i].addEventListener('change', this.onChangeRadio)
      }

      const checkboxes = this.refs.filter.querySelectorAll("input[type='checkbox']")
      for (let i = 0; i < checkboxes.length; i++) {
        checkboxes[i].addEventListener('change', this.onChangeCheckbox)
      }

      const selects = this.refs.filter.querySelectorAll('select')
      for (let i = 0; i < selects.length; i++) {
        selects[i].addEventListener('change', this.onChangeSelect)
      }
    }

    WINDOW.onresize = this.onResize

    this.state = {
      vehicle: 'Passenger Car',
      view: this.props.narrowPassengerCarCategory ? 'List' : 'Grid',
      models: null
    }
    this.tmpState = {
      vehicle: this.state.vehicle,
      view: this.state.view,
      filter: {}
    }

    this.setDefaultState()

    this.applyFilter()

    if (!this.props.narrowPassengerCarCategory) {
      this.triggerEvent(this.refs.filter, 'reset')
    } else {
      setTimeout(this.applyFilter, 10)
    }

    // if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi){
    //   console.log('[EPiServer][preview] yes');
    // }
    // else{
    //   console.log('[EPiServer][preview] no');
    // }
  }

  setDefaultState = () => {
    // URLパラメータのvehicle_typeから初期状態を設定
    let query_vehicle_type = this.getQuery('vehicle_type')
    if (query_vehicle_type !== false) {
      // 文字列整形
      const vehicleTextArr = query_vehicle_type.split('-')
      vehicleTextArr.forEach((text, index) => {
        vehicleTextArr[index] = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
      })
      query_vehicle_type = vehicleTextArr.join(' ')

      // セット
      this.tmpState.vehicle = query_vehicle_type
      this.setState({
        vehicle: query_vehicle_type
      })
    }
  };

  getQuery = (key) => {
    if (!WINDOW || !WINDOW.location) {
      return false
    }
    const params = WINDOW.location.search.substring(1).split('&')
    for (let i = 0; i < params.length; i++) {
      const param = params[i].split('=')
      if (param[0].trim() === key) {
        return param[1].trim()
      }
    }
    return false
  };

  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      narrowPassengerCarCategory,
      passengerCarFilters,
      models
    } = this.props

    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}>
        <div className="CarLineup" ref="CarLineup">
          {(() => {
            const vehicles = this.getVehicleTabNames(models)

            if (vehicles) {
              return (
                <form className={'CarLineup__VehiclesForm' + (narrowPassengerCarCategory ? ' CarLineup__VehiclesForm--hide' : '')} name="vehiclesFilter" ref="vehiclesFilter">
                  <ul className="CarLineup__VehiclesForm__List">
                    {(() => {
                      if (vehicles['Passenger Car'] && Array.isArray(vehicles['Passenger Car'])) {
                        return (
                          vehicles['Passenger Car'].map((name, index) => {
                            {
                              return (
                                <li className="CarLineup__VehiclesForm__List__Item" key={index}><label className="CarLineup__VehiclesForm__List__Item__Label"><input className="CarLineup__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Passenger Car" checked={this.state.vehicle === 'Passenger Car'} onChange={this.onChangeVehicle} /><span className="CarLineup__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                              )
                            }
                          })
                        )
                      }
                    })()}
                    {(() => {
                      if (vehicles['Light Car'] && Array.isArray(vehicles['Light Car'])) {
                        return (
                          vehicles['Light Car'].map((name, index) => {
                            {
                              return (
                                <li className="CarLineup__VehiclesForm__List__Item" key={index}><label className="CarLineup__VehiclesForm__List__Item__Label"><input className="CarLineup__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Light Car" checked={this.state.vehicle === 'Light Car'} onChange={this.onChangeVehicle} /><span className="CarLineup__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                              )
                            }
                          })
                        )
                      }
                    })()}
                    {(() => {
                      if (vehicles['Special Car'] && Array.isArray(vehicles['Special Car'])) {
                        return (
                          vehicles['Special Car'].map((name, index) => {
                            {
                              return (
                                <li className="CarLineup__VehiclesForm__List__Item" key={index}><label className="CarLineup__VehiclesForm__List__Item__Label"><input className="CarLineup__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Special Car" checked={this.state.vehicle === 'Special Car'} onChange={this.onChangeVehicle} /><span className="CarLineup__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                              )
                            }
                          })
                        )
                      }
                    })()}
                    {(() => {
                      if (vehicles['Commercial Car'] && Array.isArray(vehicles['Commercial Car'])) {
                        return (
                          vehicles['Commercial Car'].map((name, index) => {
                            {
                              return (
                                <li className="CarLineup__VehiclesForm__List__Item" key={index}><label className="CarLineup__VehiclesForm__List__Item__Label"><input className="CarLineup__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Commercial Car" checked={this.state.vehicle === 'Commercial Car'} onChange={this.onChangeVehicle} /><span className="CarLineup__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                              )
                            }
                          })
                        )
                      }
                    })()}
                    {(() => {
                      if (vehicles['Welfare Car'] && Array.isArray(vehicles['Welfare Car'])) {
                        return (
                          vehicles['Welfare Car'].map((name, index) => {
                            {
                              return (
                                <li className="CarLineup__VehiclesForm__List__Item" key={index}><label className="CarLineup__VehiclesForm__List__Item__Label"><input className="CarLineup__VehiclesForm__List__Item__Label__Radio" type="radio" name="vehicle" value="Welfare Car" checked={this.state.vehicle === 'Welfare Car'} onChange={this.onChangeVehicle} /><span className="CarLineup__VehiclesForm__List__Item__Label__Text">{name}</span></label></li>
                              )
                            }
                          })
                        )
                      }
                    })()}
                  </ul>
                </form>
              )
            }
          })()}

          {(() => {
            if (!narrowPassengerCarCategory) {
              return (
                <div className={'CarLineup__View CarLineup__View--' + (this.state.vehicle === 'Passenger Car' ? 'show' : 'hide')}>
                  <div className="CarLineup__View__Refine">
                    <a href="javascript:void(0)" onClick={this.onClickRefineOpen} className="CarLineup__View__Refine__Button">絞込条件</a>
                  </div>
                  <div className="CarLineup__View__Container">
                    <div className="CarLineup__View__Title">表示切替</div>
                    <form className="CarLineup__View__Form" name="viewFilter">
                      <ul className="CarLineup__View__Form__List">
                        <li className="CarLineup__View__Form__List__Item CarLineup__View__Form__List__Item--Grid"><label className="CarLineup__View__Form__List__Item__Label"><input className="CarLineup__View__Form__List__Item__Label__RadioButton" type="radio" name="view" value="Grid" checked={this.state.view === 'Grid'} onChange={this.onChangeView} /><span className="CarLineup__View__Form__List__Item__Label__Text">Grid</span></label></li>
                        <li className="CarLineup__View__Form__List__Item CarLineup__View__Form__List__Item--List"><label className="CarLineup__View__Form__List__Item__Label"><input className="CarLineup__View__Form__List__Item__Label__RadioButton" type="radio" name="view" value="List" checked={this.state.view === 'List'} onChange={this.onChangeView} /><span className="CarLineup__View__Form__List__Item__Label__Text">List</span></label></li>
                      </ul>
                    </form>
                  </div>
                </div>
              )
            }
          })()}

          {(() => {
            if (passengerCarFilters && !narrowPassengerCarCategory) {
              return (
                <form className={'CarLineup__FiltersForm CarLineup__FiltersForm--close CarLineup__FiltersForm--' + (this.state.vehicle === 'Passenger Car' ? 'show' : 'hide')} onChange={this.onChangeFilter} onReset={this.onResetFilter} name="carLineupFilter" ref="filter">
                  <div className="CarLineup__FiltersForm__scroll">
                    <div className="CarLineup__FiltersForm__Container">
                      <div className="CarLineup__FiltersForm__Close">
                        <a href="javascript:void(0)" onClick={this.onClickRefineClose} className="CarLineup__FiltersForm__Close__Button">close</a>
                      </div>
                      <div className="CarLineup__FiltersForm__Title">
                        <span className="CarLineup__FiltersForm__Title__Text">絞込条件</span>
                      </div>
                      <div className="CarLineup__FiltersForm__Reset CarLineup__FiltersForm__Reset--top">
                        <input type="reset" value="条件をリセット" className="CarLineup__FiltersForm__Reset__Button" />
                      </div>
                      <div className="CarLineup__FiltersForm__Body">
                        {
                          passengerCarFilters.map((data, index) => {
                            const props = Object.assign({}, data.props)
                            return (
                              <CarLineupFilter
                                {...props}
                                key={index} />
                            )
                          })
                        }
                      </div>
                      <div className="CarLineup__FiltersForm__Reset CarLineup__FiltersForm__Reset--bottom">
                        <input type="reset" value="条件リセット" className="CarLineup__FiltersForm__Reset__Button" />
                      </div>
                    </div>
                  </div>
                  <div className="CarLineup__FiltersForm__Submit">
                    <a href="javascript:void(0)" onClick={this.onClickRefineSubmit} className="CarLineup__FiltersForm__Submit__Button">指定した条件で絞込む</a>
                  </div>
                </form>
              )
            }
          })()}

          {(() => {
            if (this.state.models && this.state.models.length !== 0) {
              return (
                <div
                  className={
                    'CarLineup__Cars' +
                    ' CarLineup__Cars--' + this.state.view
                  }
                  ref="cars"
                  onTransitionEnd={(e) => {
                    e.currentTarget.classList.remove('fadein')
                    e.currentTarget.style.opacity = ''
                  }}>
                  <ul className={'CarLineup__Cars__Heading'}>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--name">名称</li>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--engine"><span>原動機</span><span>（エンジン）</span><span>タイプ</span></li>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--price"><span>価格</span><span>（消費税込）</span></li>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--supportCar">エコカー</li>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--fuelEco">燃費</li>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--passengers">乗車人数</li>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--displacement">排気量</li>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--drive"><span>駆動/</span><span>ミッション</span></li>
                    <li className="CarLineup__Cars__Heading__Item CarLineup__Cars__Heading__Item--bodySize">ボディサイズ</li>
                  </ul>
                  <ul className="CarLineup__Cars__Body">
                    {
                      this.state.models.map((model, index) => {
                        if (model.bodyTypes) {
                          return (
                            model.bodyTypes.map((bodyType, index) => {
                              let carName
                              let carCategory
                              let carPrice
                              let carImageSrc
                              let carLinkUrl

                              switch (this.state.vehicle) {
                                case 'Passenger Car':
                                case 'Light Car':
                                  carName = bodyType.bodyTypeModel ? bodyType.bodyTypeModel : null
                                  carName = carName || bodyType.carId
                                  carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null
                                  carPrice = bodyType.minPrice ? bodyType.minPrice : null
                                  carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/common/default_s.png'
                                  // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                                  carLinkUrl = '/cars/' + this.format(model.modelName).replace('roadsterrf', 'roadster-rf') + '/?car_id=' + this.format(bodyType.carId)
                                  break
                                case 'Commercial Car':
                                  carName = bodyType.bodyTypeModel ? bodyType.bodyTypeModel : null
                                  carName = carName || bodyType.carId
                                  carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null
                                  carPrice = null
                                  carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName).replace('roadsterrf', 'roadster-rf') + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/common/commercial_default_s.png'
                                  carLinkUrl = '/cars/' + this.format(model.modelName) + '/'
                                  break
                                default:
                              }

                              if (this.state.vehicle.match(/Passenger Car|Light Car|Commercial Car/)) {
                                return (
                                  <li className="CarLineup__Cars__Body__Item" key={index}>
                                    <ul className="CarLineup__Cars__Body__Item__List">
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--name">
                                        <a
                                          href={carLinkUrl}
                                          className="CarLineup__Cars__Body__Item__Link"
                                          onClick={this.onClickCarLink}
                                          data-car_id={bodyType.carId}>
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                            <img src={carImageSrc} alt={carName} className="CarLineup__Cars__Body__Item__List__Item--name__image" />
                                          </div>
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                            {carName ? <span className="CarLineup__Cars__Body__Item__List__Item--name__title" dangerouslySetInnerHTML={{ __html: convertPipeToBrTag(carName) }} /> : null}
                                            {carCategory ? <span className="CarLineup__Cars__Body__Item__List__Item--name__category">{carCategory}</span> : null}
                                            {carPrice ? <span className="CarLineup__Cars__Body__Item__List__Item--name__price">¥{Number(carPrice).toLocaleString()}〜（消費税込）</span> : null}
                                          </div>
                                        </a>
                                      </li>
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--engine">
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                          <span>原動機（エンジン）タイプ</span>
                                        </div>
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd__wrap">
                                            {(() => {
                                              if (bodyType.fuels && bodyType.fuels.length > 0) {
                                                bodyType.fuels.sort()
                                                return (
                                                  bodyType.fuels.map((fuel, index) => (
                                                    <span className="CarLineup__Cars__Body__Item__List__Item--engine__Item" key={index}>{fuel}</span>
                                                  ))
                                                )
                                              }
                                            })()}
                                          </div>
                                        </div>
                                      </li>
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--price">
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                          <span>価格</span>
                                        </div>
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd__wrap">
                                            {bodyType.minPrice ? <span>¥{Number(bodyType.minPrice).toLocaleString()}〜<span className="tax">（税込）</span></span> : null}
                                          </div>
                                        </div>
                                      </li>
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--supportCar">
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                          <span>エコカー</span>
                                        </div>
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd__wrap">
                                            {(bodyType.kankyowari && bodyType.kankyowari === true) ? <span className="CarLineup__Cars__Body__Item__List__Item--supportCar__Item">環境性能割 非課税</span> : null}
                                            {/*{(bodyType.subsidy && bodyType.subsidy === true) ? <span className="CarLineup__Cars__Body__Item__List__Item--supportCar__Item">クリーンディーゼル補助金</span> : null}*/}
                                            {(bodyType.subsidy && bodyType.subsidy === true) ? <span className="CarLineup__Cars__Body__Item__List__Item--supportCar__Item">CEV補助金</span> : null}
                                            {(() => {
                                              if (bodyType.weightTaxRate == null || bodyType.weightTaxRate === 0) {
                                                return (null)
                                              } else if (bodyType.weightTaxRate === 100) {
                                                return (<span className="CarLineup__Cars__Body__Item__List__Item--supportCar__Item">重量税 免税</span>)
                                              } else if (bodyType.weightTaxRate < 100) {
                                                return (<span className="CarLineup__Cars__Body__Item__List__Item--supportCar__Item">重量税 減税</span>)
                                              }
                                            })()}
                                          </div>
                                        </div>
                                      </li>
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--fuelEco">
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                          <span>燃費</span>
                                        </div>
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd__wrap">
                                            {(() => {
                                              if (bodyType.specSummary &&
                                                bodyType.specSummary.minWLTC && bodyType.specSummary.minWLTC > 0 &&
                                                bodyType.specSummary.maxWLTC && bodyType.specSummary.maxWLTC > 0 &&
                                                bodyType.specSummary.minWLTC === bodyType.specSummary.maxWLTC
                                              ) {
                                                return (
                                                  <React.Fragment>
                                                    <span className="CarLineup__Cars__Body__Item__List__Item--fuelEco__Title">WLTCモード</span>
                                                    <span>{bodyType.specSummary.minWLTC}</span>
                                                    <span>km/L</span>
                                                  </React.Fragment>
                                                )
                                              }

                                              return (
                                                <React.Fragment>
                                                  {bodyType.specSummary && (bodyType.specSummary.minWLTC || bodyType.specSummary.maxWLTC) ? <span className="CarLineup__Cars__Body__Item__List__Item--fuelEco__Title">WLTCモード</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.minWLTC && bodyType.specSummary.minWLTC > 0) ? <span>{bodyType.specSummary.minWLTC}</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.maxWLTC && bodyType.specSummary.maxWLTC > 0) ? <span>〜{bodyType.specSummary.maxWLTC}</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.minWLTC || bodyType.specSummary.maxWLTC) ? <span>km/L</span> : null}
                                                </React.Fragment>
                                              )
                                            })()}
                                            {(() => {
                                              if (bodyType.specSummary &&
                                                bodyType.specSummary.minJC08 && bodyType.specSummary.minJC08 > 0 &&
                                                bodyType.specSummary.maxJC08 && bodyType.specSummary.maxJC08 > 0 &&
                                                bodyType.specSummary.minJC08 === bodyType.specSummary.maxJC08
                                              ) {
                                                return (
                                                  <React.Fragment>
                                                    <span className="CarLineup__Cars__Body__Item__List__Item--fuelEco__Title">JC08モード</span>
                                                    <span>{bodyType.specSummary.minJC08}</span>
                                                    <span>km/L</span>
                                                  </React.Fragment>
                                                )
                                              }

                                              return (
                                                <React.Fragment>
                                                  {bodyType.specSummary && (bodyType.specSummary.minJC08 || bodyType.specSummary.maxJC08) ? <span className="CarLineup__Cars__Body__Item__List__Item--fuelEco__Title">JC08モード</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.minJC08 && bodyType.specSummary.minJC08 > 0) ? <span>{bodyType.specSummary.minJC08}</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.maxJC08 && bodyType.specSummary.maxJC08 > 0) ? <span>〜{bodyType.specSummary.maxJC08}</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.minJC08 || bodyType.specSummary.maxJC08) ? <span>km/L</span> : null}
                                                </React.Fragment>
                                              )
                                            })()}
                                          </div>
                                        </div>
                                        <span />
                                      </li>
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--passengers">
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                          <span>乗車人数</span>
                                        </div>
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd__wrap">
                                            {bodyType.specSummary && (bodyType.specSummary.passengers && Array.isArray(bodyType.specSummary.passengers)) ? <span>{bodyType.specSummary.passengers.join(' | ')}名</span> : null}
                                          </div>
                                        </div>
                                      </li>
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--displacement">
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                          <span>排気量</span>
                                        </div>
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd__wrap">
                                            {(() => {
                                              if (bodyType.specSummary &&
                                                bodyType.specSummary.minDisplacement && bodyType.specSummary.minDisplacement > 0 &&
                                                bodyType.specSummary.maxDisplacement && bodyType.specSummary.maxDisplacement > 0 &&
                                                bodyType.specSummary.minDisplacement === bodyType.specSummary.maxDisplacement
                                              ) {
                                                return (
                                                  <React.Fragment>
                                                    <span>{Number(bodyType.specSummary.minDisplacement).toLocaleString()}</span>
                                                    <span>L</span>
                                                  </React.Fragment>
                                                )
                                              }

                                              return (
                                                <React.Fragment>
                                                  {bodyType.specSummary && (bodyType.specSummary.minDisplacement && bodyType.specSummary.minDisplacement > 0) ? <span>{Number(bodyType.specSummary.minDisplacement).toLocaleString()}</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.maxDisplacement && bodyType.specSummary.maxDisplacement > 0) ? <span className="tilde">〜</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.maxDisplacement && bodyType.specSummary.maxDisplacement > 0) ? <span>{Number(bodyType.specSummary.maxDisplacement).toLocaleString()}</span> : null}
                                                  {bodyType.specSummary && (bodyType.specSummary.minDisplacement || bodyType.specSummary.maxDisplacement) ? <span>L</span> : null}
                                                </React.Fragment>
                                              )
                                            })()}
                                          </div>
                                        </div>
                                      </li>
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--drive">
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                          <span>駆動/ミッション</span>
                                        </div>
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd__wrap">
                                            {bodyType.drives ? <span className="CarLineup__Cars__Body__Item__List__Item--drive__Item">{Array.isArray(bodyType.drives) ? bodyType.drives.sort().join('/') : null}</span> : null}
                                            {bodyType.transmissions ? <span className="CarLineup__Cars__Body__Item__List__Item--drive__Item">{Array.isArray(bodyType.transmissions) ? bodyType.transmissions.sort().join('/') : null}</span> : null}
                                          </div>
                                        </div>
                                      </li>
                                      <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--bodySize">
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                          <span>ボディサイズ</span>
                                        </div>
                                        <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                          <div className="CarLineup__Cars__Body__Item__List__Item__dd__wrap">
                                            <div className="CarLineup__Cars__Body__Item__List__Item--bodySize__Item">
                                              {(() => {
                                                if (bodyType.specSummary &&
                                                  bodyType.specSummary.minLength &&
                                                  bodyType.specSummary.maxLength &&
                                                  bodyType.specSummary.minLength === bodyType.specSummary.maxLength
                                                ) {
                                                  return (
                                                    <React.Fragment>
                                                      <span>全長：</span>
                                                      <span>{Number(bodyType.specSummary.minLength).toLocaleString()}</span>
                                                      <span>mm</span>
                                                    </React.Fragment>
                                                  )
                                                }

                                                return (
                                                  <React.Fragment>
                                                    {bodyType.specSummary && (bodyType.specSummary.minLength || bodyType.specSummary.maxLength) ? <span>全長：</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.minLength) ? <span>{Number(bodyType.specSummary.minLength).toLocaleString()}</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.maxLength) ? <span>〜{Number(bodyType.specSummary.maxLength).toLocaleString()}</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.minLength || bodyType.specSummary.maxLength) ? <span>mm</span> : null}
                                                  </React.Fragment>
                                                )
                                              })()}
                                            </div>
                                            <div className="CarLineup__Cars__Body__Item__List__Item--bodySize__Item">
                                              {(() => {
                                                if (bodyType.specSummary &&
                                                  bodyType.specSummary.minWidth &&
                                                  bodyType.specSummary.maxWidth &&
                                                  bodyType.specSummary.minWidth === bodyType.specSummary.maxWidth
                                                ) {
                                                  return (
                                                    <React.Fragment>
                                                      <span>全幅：</span>
                                                      <span>{Number(bodyType.specSummary.minWidth).toLocaleString()}</span>
                                                      <span>mm</span>
                                                    </React.Fragment>
                                                  )
                                                }

                                                return (
                                                  <React.Fragment>
                                                    {bodyType.specSummary && (bodyType.specSummary.minWidth || bodyType.specSummary.maxWidth) ? <span>全幅：</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.minWidth) ? <span>{Number(bodyType.specSummary.minWidth).toLocaleString()}</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.maxWidth) ? <span>〜{Number(bodyType.specSummary.maxWidth).toLocaleString()}</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.minWidth || bodyType.specSummary.maxWidth) ? <span>mm</span> : null}
                                                  </React.Fragment>
                                                )
                                              })()}
                                            </div>
                                            <div className="CarLineup__Cars__Body__Item__List__Item--bodySize__Item">
                                              {(() => {
                                                if (bodyType.specSummary &&
                                                  bodyType.specSummary.minHeight &&
                                                  bodyType.specSummary.maxHeight &&
                                                  bodyType.specSummary.minHeight === bodyType.specSummary.maxHeight
                                                ) {
                                                  return (
                                                    <React.Fragment>
                                                      <span>全高：</span>
                                                      <span>{Number(bodyType.specSummary.minHeight).toLocaleString()}</span>
                                                      <span>mm</span>
                                                    </React.Fragment>
                                                  )
                                                }

                                                return (
                                                  <React.Fragment>
                                                    {bodyType.specSummary && (bodyType.specSummary.minHeight || bodyType.specSummary.maxHeight) ? <span>全高：</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.minHeight) ? <span>{Number(bodyType.specSummary.minHeight).toLocaleString()}</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.maxHeight) ? <span>〜{Number(bodyType.specSummary.maxHeight).toLocaleString()}</span> : null}
                                                    {bodyType.specSummary && (bodyType.specSummary.minHeight || bodyType.specSummary.maxHeight) ? <span>mm</span> : null}
                                                  </React.Fragment>
                                                )
                                              })()}
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </li>
                                )
                              } else if (this.state.vehicle.match(/Special Car|Welfare Car/)) {
                                if (bodyType.grades) {
                                  return (
                                    bodyType.grades.map((grade, index) => {
                                      switch (this.state.vehicle) {
                                        case 'Special Car':
                                          carName = grade && grade.gradeName ? grade.gradeName : null
                                          carCategory = bodyType.bodyTypeCategory ? bodyType.bodyTypeCategory : null
                                          carPrice = grade && grade.minPrice ? grade.minPrice : null
                                          carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/' + this.format(grade.gradeId) + '/common/' + this.format(grade.gradeId) + '_default_s.png'
                                          // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                                          carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : ''
                                          break
                                        case 'Welfare Car':
                                          carName = grade && grade.gradeName ? grade.gradeName : null
                                          carCategory = grade && grade.welfareCarTypeCategory ? grade.welfareCarTypeCategory : null
                                          carPrice = null
                                          carImageSrc = '/globalassets/assets/cars/' + this.format(model.modelName) + '/' + this.format(bodyType.carId) + '/' + this.format(bodyType.carTypeCode) + '/' + this.format(grade.gradeId) + '/common/welfare_' + this.format(grade.gradeId) + '_default_s.png'
                                          // carImageSrc = '/assets-dev/MX5_SoulRed.png';
                                          carLinkUrl = grade.carLineupUrl != null && grade.carLineupUrl !== '' ? grade.carLineupUrl : ''
                                          break
                                        default:
                                      }


                                      return (
                                        <li className="CarLineup__Cars__Body__Item" key={index}>
                                          <ul className="CarLineup__Cars__Body__Item__List">
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--name">
                                              <a
                                                href={carLinkUrl}
                                                className={'CarLineup__Cars__Body__Item__Link' + (!carLinkUrl ? ' CarLineup__Cars__Body__Item__Link--disabled' : '')}
                                                onClick={this.onClickCarLink}
                                                data-car_id={bodyType.carId}
                                                data-grade_id={grade.gradeId}
                                                disabled={!carLinkUrl ? 'disabled' : null}>
                                                <div className="CarLineup__Cars__Body__Item__List__Item__dd">
                                                  <img src={carImageSrc} alt={carName} className="CarLineup__Cars__Body__Item__List__Item--name__image" />
                                                </div>
                                                <div className="CarLineup__Cars__Body__Item__List__Item__dt">
                                                  {carName ? <span className="CarLineup__Cars__Body__Item__List__Item--name__title" dangerouslySetInnerHTML={{ __html: convertPipeToBrTag(carName) }} /> : null}
                                                  {carCategory ? <span className="CarLineup__Cars__Body__Item__List__Item--name__category">{carCategory}</span> : null}
                                                  {carPrice ? <span className="CarLineup__Cars__Body__Item__List__Item--name__price">¥{Number(carPrice).toLocaleString()}〜（税込）</span> : null}
                                                </div>
                                              </a>
                                            </li>
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--engine" />
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--price" />
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--supportCar" />
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--fuelEco" />
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--passengers" />
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--displacement" />
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--drive" />
                                            <li className="CarLineup__Cars__Body__Item__List__Item CarLineup__Cars__Body__Item__List__Item--bodySize" />
                                          </ul>
                                        </li>
                                      )
                                    })
                                  )
                                }
                              }
                            })
                          )
                        }
                      })
                    }
                  </ul>
                </div>
              )
            } else if (this.state.models && this.state.models.length === 0) {
              return (
                <div
                  className={
                    'CarLineup__Cars' +
                    ' CarLineup__Cars--' + this.state.view
                  }
                  ref="cars"
                  onTransitionEnd={(e) => {
                    e.currentTarget.classList.remove('fadein')
                    e.currentTarget.style.opacity = ''
                  }}>
                  <div className={'CarLineup__Cars__noResult'}>
                    <p>該当する車がありません。<br className="br" />条件を変えて検索してください。</p>
                  </div>
                </div>
              )
            }
          })()}


        </div>
      </Wrapper>
    )
  }

  onChangeVehicle = (e) => {
    this.setState({
      vehicle: e.target.value,
      view: e.target.value === 'Passenger Car' ? this.tmpState.view : 'Grid'
    })

    this.applyFilter()

    if (IS_MOBILE) {
      this.slideVehicleNavi()
    }
  };

  slideVehicleNavi = () => {
    const checkedRadio = this.refs.vehiclesFilter.querySelector("input[type='radio']:checked")
    const current = checkedRadio.parentNode.parentNode
    const parent = current.parentNode
    const currentRect = current.getBoundingClientRect()
    const parentRect = parent.getBoundingClientRect()

    const children = parent.children
    let child
    let currentLeft = 0
    let totalWidth = 0
    for (let i = 0; i < parent.children.length; i++) {
      child = parent.children[i]
      totalWidth += child.getBoundingClientRect().width
    }
    for (let i = 0; i < parent.children.length; i++) {
      child = parent.children[i]
      if (child === current) {
        break
      }
      currentLeft += child.getBoundingClientRect().width
    }

    let scrollLeft = currentLeft - parentRect.width / 2 + currentRect.width / 2
    scrollLeft = scrollLeft < 0 ? 0 : scrollLeft

    if (totalWidth - scrollLeft < parentRect.width) {
      scrollLeft = totalWidth - parentRect.width
    }

    scrollLeft = Math.floor(scrollLeft)

    clearInterval(this.vehicleIntervalId)
    this.vehicleIntervalId = setInterval(
      () => {
        if (scrollLeft - parent.scrollLeft < 0) {
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * -0.1) * -1
        } else {
          parent.scrollLeft += Math.ceil((scrollLeft - parent.scrollLeft) * 0.1)
        }

        if (Math.abs(scrollLeft - parent.scrollLeft) < 1) {
          parent.scrollLeft = scrollLeft
          clearInterval(this.vehicleIntervalId)
        }
        // console.log(parent.scrollLeft, scrollLeft);
      },
      1000 / 60
    )
  };

  onChangeView = (e) => {
    this.setState({
      view: e.target.value
    })

    if (this.state.vehicle === 'Passenger Car') {
      this.tmpState.view = e.target.value
    }

    this.applyFilter()
  };

  onChangeFilter = (e) => {
    this.applyFilter()
  };

  onResetFilter = (e) => {
    setTimeout(
      this.applyFilter,
      10
    )
  };

  onClickRadio = (e) => {
    if (e.target.type === 'radio') {
      this.applyFilter()
      e.stopPropagation()
    }
  };

  onChangeRadio = (e) => {
    if (e.target.type === 'radio' && e.target.checked === true) {
      const label = e.target.parentNode
      const text = e.target.name + ':' + label.innerText.trim()
      this.sendGTM(text)
      e.stopPropagation()
    }
  }

  onChangeCheckbox = (e) => {
    if (e.target.type === 'checkbox' && e.target.checked === true) {
      const label = e.target.parentNode
      const text = e.target.name + ':' + label.innerText.trim()
      this.sendGTM(text)
      e.stopPropagation()
    }
  }

  onChangeSelect = (e) => {
    const selectedIndex = e.target.selectedIndex
    const text = e.target.name + ':' + e.target.options[selectedIndex].text.trim()
    this.sendGTM(text)
    e.stopPropagation()
    this.applyFilter()
  }

  onClickRefineOpen = (e) => {
    const filter = this.refs.filter
    filter.classList.remove('CarLineup__FiltersForm--close')
    filter.classList.add('CarLineup__FiltersForm--open')

    this.refs.cars.classList.add('fadein-mb')

    // document.body.classList.add('un-scroll-mb');
    BodyControl.setUnScrollMb()
    BodyControl.openModal()

    e.preventDefault()

    // 一時記録
    this.tmpState.filter = {
      bodyType: filter.bodyType.value,
      engineType: filter.engineType.value,
      mission: filter.mission.value,
      drive: filter.drive.value,
      capacity: filter.capacity.value,
      price: filter.price.value,
      minDisplacement: filter.minDisplacement.value,
      maxDisplacement: filter.maxDisplacement.value,
      bodySizeLength: filter.bodySizeLength.value,
      bodySizeWidth: filter.bodySizeWidth.value,
      bodySizeHeight: filter.bodySizeHeight.value,
      othersSv: filter.othersSv.checked,
      // othersSupportCar: filter.othersSupportCar.checked,
      othersSupportCar: [],
      othersEcoTax: filter.othersEcoTax.checked,
      othersSubsidy: filter.othersSubsidy.checked
    }

    for (let i = 0; i < filter.othersSupportCar.length; i++) {
      this.tmpState.filter.othersSupportCar[i] = filter.othersSupportCar[i].checked
    }
  };

  onClickRefineClose = (e) => {
    const filter = this.refs.filter
    filter.classList.remove('CarLineup__FiltersForm--open')
    filter.classList.add('CarLineup__FiltersForm--close')

    this.refs.cars.classList.remove('fadein-mb')

    // document.body.classList.remove('un-scroll-mb');
    BodyControl.clearUnScroll()
    BodyControl.closeModal()

    e.preventDefault()

    // 復帰前にフォーム内容をクリア
    filter.reset()

    // 一時記録から復帰
    filter.bodyType.value = this.tmpState.filter.bodyType
    filter.engineType.value = this.tmpState.filter.engineType
    filter.mission.value = this.tmpState.filter.mission
    filter.drive.value = this.tmpState.filter.drive
    filter.capacity.value = this.tmpState.filter.capacity
    filter.price.value = this.tmpState.filter.price
    filter.minDisplacement.value = this.tmpState.filter.minDisplacement
    filter.maxDisplacement.value = this.tmpState.filter.maxDisplacement
    filter.bodySizeLength.value = this.tmpState.filter.bodySizeLength
    filter.bodySizeWidth.value = this.tmpState.filter.bodySizeWidth
    filter.bodySizeHeight.value = this.tmpState.filter.bodySizeHeight
    filter.othersSv.checked = this.tmpState.filter.othersSv
    // filter.othersSupportCar.checked = this.tmpState.filter.othersSupportCar;
    filter.othersEcoTax.checked = this.tmpState.filter.othersEcoTax
    filter.othersSubsidy.checked = this.tmpState.filter.othersSubsidy

    for (let i = 0; i < filter.othersSupportCar.length; i++) {
      filter.othersSupportCar[i].checked = Boolean(this.tmpState.filter.othersSupportCar[i])
    }

    this.tmpState.filter = {}

    this.applyFilter()
  };

  onClickRefineSubmit = (e) => {
    const filter = this.refs.filter
    filter.classList.remove('CarLineup__FiltersForm--open')
    filter.classList.add('CarLineup__FiltersForm--close')

    this.refs.cars.classList.remove('fadein-mb')

    // document.body.classList.remove('un-scroll-mb');
    BodyControl.clearUnScroll()
    BodyControl.closeModal()

    e.preventDefault()

    this.applyFilter()
  };

  onClickCarLink = (e) => {
    // let date = new Date();
    // date.setTime(date.getTime() + 24 * 60 * 60 * 1000); //24h
    // let expires = date.toGMTString();

    // if(DOCUMENT){
    //   if(e.currentTarget.dataset.car_id){
    //     DOCUMENT.cookie = "mj_carid=" + e.currentTarget.dataset.car_id + ";expires=" + expires + ";path=/";
    //   }
    //   if(e.currentTarget.dataset.grade_id){
    //     DOCUMENT.cookie = "mj_grade=" + e.currentTarget.dataset.grade_id + ";expires=" + expires + ";path=/";
    //   }
    // }

    if (WINDOW) {
      WINDOW.location.href = e.currentTarget.href
    }

    e.preventDefault()
    return false
  };

  getVehicleTabNames = (models) => {
    // Passenger Car/Light Car/Special Car/Commercial Car/Welfare Car/
    const vehicles = {
      'Passenger Car': [],
      'Light Car': [],
      'Special Car': [],
      'Commercial Car': [],
      'Welfare Car': []
    }

    if (models) {
      models.map((model, index) => {
        if (model.vehicleType === 'Passenger Car' && model.vehicleTabName !== '') {
          vehicles['Passenger Car'].push(model.vehicleTabName)
        } else if (model.vehicleType === 'Light Car' && model.vehicleTabName !== '') {
          vehicles['Light Car'].push(model.vehicleTabName)
        } else if (model.vehicleType === 'Commercial Car' && model.vehicleTabName !== '') {
          vehicles['Commercial Car'].push(model.vehicleTabName)
        }

        if (model.bodyTypes && Array.isArray(model.bodyTypes)) {
          model.bodyTypes.map((bodyType, index) => {
            if (bodyType.grades && Array.isArray(bodyType.grades)) {
              bodyType.grades.map((grade, index) => {
                if (grade.specialCar === true && grade.specialCarTabName && grade.specialCarTabName !== '') {
                  vehicles['Special Car'].push(grade.specialCarTabName)
                } else if (grade.welfareCar === true && grade.welfareCarTabName && grade.welfareCarTabName !== '') {
                  vehicles['Welfare Car'].push(grade.welfareCarTabName)
                }
              })
            }
          })
        }
      })
    }

    for (const vehicleType in vehicles) {
      if (vehicles.hasOwnProperty(vehicleType)) {
        // 重複を削除
        vehicles[vehicleType] = vehicles[vehicleType].filter((x, i, self) => self.indexOf(x) === i)
      }
    }

    return vehicles
  };

  sendGTM = (text) => {
    dataLayer = dataLayer || []
    dataLayer.push({
      trackfliter: text,
      event: 'CarLineupFilterSelect'
    })
  }

  applyFilter = () => {
    const vehicles = this.refs.vehiclesFilter
    const filter = this.refs.filter

    if (this.refs.cars != null && this.refs.cars.classList != null) {
      this.refs.cars.classList.remove('fadein')
      this.refs.cars.style.opacity = 0
      setTimeout(
        () => {
          this.refs.cars.classList.add('fadein')
          this.refs.cars.style.opacity = 1
        },
        10
      )
    }

    let currentVehicleType = ''
    for (let i = 0; i < vehicles.vehicle.length; i++) {
      if (vehicles.vehicle[i].checked) {
        currentVehicleType = vehicles.vehicle[i].value
        break
      }
    }

    const models = JSON.parse(JSON.stringify(this.props.models))
    if (models && models.length > 0) {
      let i = models.length
      while (i--) {
        // 車種（Passenger Car/Light Car/Commercial Car）
        if (currentVehicleType.match(/Passenger Car|Light Car|Commercial Car/) && models[i].vehicleType !== currentVehicleType) {
          models.splice(i, 1)
          continue
        }

        if (currentVehicleType.match(/Passenger Car|Light Car|Commercial Car/)) {
          const bodyTypes = models[i].bodyTypes
          if (bodyTypes && bodyTypes.length > 0) {
            let j = bodyTypes.length
            loopBodyType: while (j--) {
              const bodyType = bodyTypes[j]

              const hasSv = this.hasSpecialVehicle(bodyType.carId)

              if (filter && currentVehicleType.match(/Passenger Car/)) {
                if (filter.othersSv != null && filter.othersSv.checked) {
                  if (!hasSv && bodyType.grades == null) {
                    bodyTypes.splice(j, 1)
                    continue
                  }
                }
              }

              if (bodyType.grades && Array.isArray(bodyType.grades) && bodyType.grades.length > 0) {
                let k = bodyType.grades.length
                while (k--) {
                  const grade = bodyType.grades[k]
                  if (grade.welfareCar === true) {
                    bodyTypes.splice(j, 1)
                    continue loopBodyType
                  }
                  if (grade.specialCar === true) {
                    bodyTypes.splice(j, 1)
                    continue loopBodyType
                  }
                }
              }
            }
          }
        }

        if (true) {
          const bodyTypes = models[i].bodyTypes
          if (bodyTypes && bodyTypes.length > 0) {
            let j = bodyTypes.length
            loopBodyType: while (j--) {
              const bodyType = bodyTypes[j]
              if (bodyType.grades && Array.isArray(bodyType.grades) && bodyType.grades.length > 0) {
                let k = bodyType.grades.length
                while (k--) {
                  const grade = bodyType.grades[k]
                  // 特別仕様車チェック
                  if (currentVehicleType.match(/Special Car/) && (grade === null || grade.specialCar !== true || grade.specialCarDefaultGrade !== true)) {
                    bodyType.grades.splice(k, 1)
                    continue
                  }
                  // 福祉車両チェック
                  else if (currentVehicleType.match(/Welfare Car/) && (grade === null || grade.welfareCar !== true || grade.welfareCarDefaultGrade !== true)) {
                    bodyType.grades.splice(k, 1)
                    continue
                  }
                }
                if (bodyType.grades.length === 0) {
                  delete bodyType.grades
                }
              }
              if (currentVehicleType.match(/Special Car/) || currentVehicleType.match(/Welfare Car/)) {
                if (!bodyType.grades || bodyType.grades.length === 0) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }

              // filterが無い（narrowPassengerCarCategory が true）の時は検索フィルタをかけない
              if (!filter) {
                continue
              }

              // 「Passenger Car（乗用車）」の時のみ検索フィルタをかける
              if (currentVehicleType !== 'Passenger Car') {
                continue
              }
              // 以下、検索フィルタ
              const _bodyTypeValue = this.getFilterValue(filter, 'bodyType')
              if (_bodyTypeValue != null && _bodyTypeValue !== '') {
                if (bodyType.bodyTypeCategory !== _bodyTypeValue) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              const _engineTypeValue = this.getFilterValue(filter, 'engineType')
              if (_engineTypeValue != null && _engineTypeValue !== '') {
                if (!this.inArray(bodyType.fuels, _engineTypeValue)) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              const _missionValue = this.getFilterValue(filter, 'mission')
              if (_missionValue != null && _missionValue !== '') {
                if (!this.inArray(bodyType.transmissions, _missionValue)) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              const _driveValue = this.getFilterValue(filter, 'drive')
              if (_driveValue != null && _driveValue !== '') {
                if (!this.inArray(bodyType.drives, _driveValue)) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              const _capacityValue = this.getFilterValue(filter, 'capacity')
              if (_capacityValue != null && Number(_capacityValue) > 0) {
                let value = 0
                let operator = ''
                let isMatch = false
                if (bodyType.specSummary == null || bodyType.specSummary.passengers == null || !Array.isArray(bodyType.specSummary.passengers)) {
                  bodyTypes.splice(j, 1)
                  continue
                }
                for (let k = 0; k < filter.capacity.length; k++) {
                  if (filter.capacity[k].checked) {
                    value = filter.capacity[k].value
                    operator = filter.capacity[k].dataset.operator
                  }
                }

                let minCapacity,
                  maxCapacity
                for (let k = 0; k < bodyType.specSummary.passengers.length; k++) {
                  if (minCapacity == null) {
                    minCapacity = Number(bodyType.specSummary.passengers[k])
                  }
                  if (maxCapacity == null) {
                    maxCapacity = Number(bodyType.specSummary.passengers[k])
                  }
                  minCapacity = Math.min(bodyType.specSummary.passengers[k], minCapacity)
                  maxCapacity = Math.max(bodyType.specSummary.passengers[k], maxCapacity)
                }
                switch (operator) {
                  case '=':
                    isMatch = !!(Number(minCapacity) === Number(value) && Number(maxCapacity) === Number(value))
                    break
                  case '<':
                    isMatch = Number(maxCapacity) < Number(value)
                    break
                  case '<=':
                    isMatch = Number(maxCapacity) <= Number(value)
                    break
                  case '>':
                    isMatch = Number(minCapacity) > Number(value)
                    break
                  case '>=':
                    isMatch = Number(minCapacity) >= Number(value)
                    break
                  default:
                    isMatch = !!(Number(minCapacity) === Number(value) && Number(maxCapacity) === Number(value))
                }
                if (!isMatch) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              if (filter.price != null && filter.price.value != null && Number(filter.price.value) > 0) {
                const operator = filter.price.options[filter.price.options.selectedIndex].dataset.operator
                let isMatch = false
                if (bodyType.minPrice == null) {
                  bodyTypes.splice(j, 1)
                  continue
                }
                switch (operator) {
                  case '=':
                    isMatch = Number(bodyType.minPrice) === Number(filter.price.value)
                    break
                  case '<':
                    isMatch = Number(bodyType.minPrice) < Number(filter.price.value)
                    break
                  case '<=':
                    isMatch = Number(bodyType.minPrice) <= Number(filter.price.value)
                    break
                  case '>':
                    isMatch = Number(bodyType.minPrice) > Number(filter.price.value)
                    break
                  case '>=':
                    isMatch = Number(bodyType.minPrice) >= Number(filter.price.value)
                    break
                  default:
                    isMatch = Number(bodyType.minPrice) === Number(filter.price.value)
                }
                if (!isMatch) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              if (filter.minDisplacement != null && filter.minDisplacement.value != null && Number(filter.minDisplacement.value) > 0) {
                const operator = filter.minDisplacement.options[filter.minDisplacement.options.selectedIndex].dataset.operator
                let isMatch = false
                if (bodyType.specSummary == null || bodyType.specSummary.minDisplacement == null) {
                  bodyTypes.splice(j, 1)
                  continue
                }
                switch (operator) {
                  case '=':
                    isMatch = Number(bodyType.specSummary.minDisplacement) === Number(filter.minDisplacement.value)
                    break
                  case '<':
                    isMatch = Number(bodyType.specSummary.minDisplacement) < Number(filter.minDisplacement.value)
                    break
                  case '<=':
                    isMatch = Number(bodyType.specSummary.minDisplacement) <= Number(filter.minDisplacement.value)
                    break
                  case '>':
                    isMatch = Number(bodyType.specSummary.minDisplacement) > Number(filter.minDisplacement.value)
                    break
                  case '>=':
                    isMatch = Number(bodyType.specSummary.minDisplacement) >= Number(filter.minDisplacement.value)
                    break
                  default:
                    isMatch = Number(bodyType.specSummary.minDisplacement) === Number(filter.minDisplacement.value)
                }
                if (!isMatch) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              if (filter.maxDisplacement != null && filter.maxDisplacement.value != null && Number(filter.maxDisplacement.value) > 0) {
                const operator = filter.maxDisplacement.options[filter.maxDisplacement.options.selectedIndex].dataset.operator
                let isMatch = false
                if (bodyType.specSummary == null || bodyType.specSummary.maxDisplacement == null) {
                  bodyTypes.splice(j, 1)
                  continue
                }
                switch (operator) {
                  case '=':
                    isMatch = Number(bodyType.specSummary.maxDisplacement) === Number(filter.maxDisplacement.value)
                    break
                  case '<':
                    isMatch = Number(bodyType.specSummary.maxDisplacement) < Number(filter.maxDisplacement.value)
                    break
                  case '<=':
                    isMatch = Number(bodyType.specSummary.maxDisplacement) <= Number(filter.maxDisplacement.value)
                    break
                  case '>':
                    isMatch = Number(bodyType.specSummary.maxDisplacement) > Number(filter.maxDisplacement.value)
                    break
                  case '>=':
                    isMatch = Number(bodyType.specSummary.maxDisplacement) >= Number(filter.maxDisplacement.value)
                    break
                  default:
                    isMatch = Number(bodyType.specSummary.maxDisplacement) === Number(filter.maxDisplacement.value)
                }
                if (!isMatch) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              if (filter.bodySizeLength != null && filter.bodySizeLength.value != null && Number(filter.bodySizeLength.value) > 0) {
                const operator = filter.bodySizeLength.options[filter.bodySizeLength.options.selectedIndex].dataset.operator
                let isMatch = false
                if (bodyType.specSummary == null || bodyType.specSummary.minLength == null || bodyType.specSummary.maxLength == null) {
                  bodyTypes.splice(j, 1)
                  continue
                }
                switch (operator) {
                  case '=':
                    isMatch = !!((Number(bodyType.specSummary.minLength) === Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) === Number(filter.bodySizeLength.value)))
                    break
                  case '<':
                    // isMatch = (Number(bodyType.specSummary.minLength) < Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) < Number(filter.bodySizeLength.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minLength) < Number(filter.bodySizeLength.value))
                    break
                  case '<=':
                    // isMatch = (Number(bodyType.specSummary.minLength) <= Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) <= Number(filter.bodySizeLength.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minLength) <= Number(filter.bodySizeLength.value))
                    break
                  case '>':
                    // isMatch = (Number(bodyType.specSummary.minLength) > Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) > Number(filter.bodySizeLength.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minLength) > Number(filter.bodySizeLength.value))
                    break
                  case '>=':
                    // isMatch = (Number(bodyType.specSummary.minLength) >= Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) >= Number(filter.bodySizeLength.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minLength) >= Number(filter.bodySizeLength.value))
                    break
                  default:
                    isMatch = !!((Number(bodyType.specSummary.minLength) === Number(filter.bodySizeLength.value) || Number(bodyType.specSummary.maxLength) === Number(filter.bodySizeLength.value)))
                }
                if (!isMatch) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              if (filter.bodySizeWidth != null && filter.bodySizeWidth.value != null && Number(filter.bodySizeWidth.value) > 0) {
                const operator = filter.bodySizeWidth.options[filter.bodySizeWidth.options.selectedIndex].dataset.operator
                let isMatch = false
                if (bodyType.specSummary == null || bodyType.specSummary.minWidth == null || bodyType.specSummary.maxWidth == null) {
                  bodyTypes.splice(j, 1)
                  continue
                }
                switch (operator) {
                  case '=':
                    isMatch = !!((Number(bodyType.specSummary.minWidth) === Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) === Number(filter.bodySizeWidth.value)))
                    break
                  case '<':
                    // isMatch = (Number(bodyType.specSummary.minWidth) < Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) < Number(filter.bodySizeWidth.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minWidth) < Number(filter.bodySizeWidth.value))
                    break
                  case '<=':
                    // isMatch = (Number(bodyType.specSummary.minWidth) <= Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) <= Number(filter.bodySizeWidth.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minWidth) <= Number(filter.bodySizeWidth.value))
                    break
                  case '>':
                    // isMatch = (Number(bodyType.specSummary.minWidth) > Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) > Number(filter.bodySizeWidth.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minWidth) > Number(filter.bodySizeWidth.value))
                    break
                  case '>=':
                    // isMatch = (Number(bodyType.specSummary.minWidth) >= Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) >= Number(filter.bodySizeWidth.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minWidth) >= Number(filter.bodySizeWidth.value))
                    break
                  default:
                    isMatch = !!((Number(bodyType.specSummary.minWidth) === Number(filter.bodySizeWidth.value) || Number(bodyType.specSummary.maxWidth) === Number(filter.bodySizeWidth.value)))
                }
                if (!isMatch) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              if (filter.bodySizeHeight != null && filter.bodySizeHeight.value != null && Number(filter.bodySizeHeight.value) > 0) {
                const operator = filter.bodySizeHeight.options[filter.bodySizeHeight.options.selectedIndex].dataset.operator
                let isMatch = false
                if (bodyType.specSummary == null || bodyType.specSummary.minHeight == null || bodyType.specSummary.maxHeight == null) {
                  bodyTypes.splice(j, 1)
                  continue
                }
                switch (operator) {
                  case '=':
                    isMatch = !!((Number(bodyType.specSummary.minHeight) === Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) === Number(filter.bodySizeHeight.value)))
                    break
                  case '<':
                    // isMatch = (Number(bodyType.specSummary.minHeight) < Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) < Number(filter.bodySizeHeight.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minHeight) < Number(filter.bodySizeHeight.value))
                    break
                  case '<=':
                    // isMatch = (Number(bodyType.specSummary.minHeight) <= Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) <= Number(filter.bodySizeHeight.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minHeight) <= Number(filter.bodySizeHeight.value))
                    break
                  case '>':
                    // isMatch = (Number(bodyType.specSummary.minHeight) > Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) > Number(filter.bodySizeHeight.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minHeight) > Number(filter.bodySizeHeight.value))
                    break
                  case '>=':
                    // isMatch = (Number(bodyType.specSummary.minHeight) >= Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) >= Number(filter.bodySizeHeight.value)) ? true : false;
                    isMatch = (Number(bodyType.specSummary.minHeight) >= Number(filter.bodySizeHeight.value))
                    break
                  default:
                    isMatch = !!((Number(bodyType.specSummary.minHeight) === Number(filter.bodySizeHeight.value) || Number(bodyType.specSummary.maxHeight) === Number(filter.bodySizeHeight.value)))
                }
                if (!isMatch) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              // if( filter.othersSv != null && filter.othersSv.checked ){
              //   let isMatch = false;
              //   if(bodyType.grades != null && Array.isArray(bodyType.grades) && bodyType.grades.length > 0){
              //     let k = bodyType.grades.length;
              //     loopGrade:while(k--) {
              //       let grade = bodyType.grades[k];
              //       if(grade != null && grade.specialCar === true){
              //         isMatch = true;
              //         break loopGrade;
              //       }
              //     }
              //   }
              //   if(!isMatch){
              //     bodyTypes.splice(j, 1);
              //     continue loopBodyType;
              //   }
              // }
              // if (filter.othersSupportCar != null) {
              //   // ひとつのみ（配列ではない）
              //   if (isNaN(filter.othersSupportCar.length)) {
              //     if (bodyType.supportCar != null && !this.inArray(bodyType.supportCar, filter.othersSupportCar.value) && filter.othersSupportCar.checked) {
              //       bodyTypes.splice(j, 1)
              //       continue
              //     }
              //     if (bodyType.supportCar == null && filter.othersSupportCar.checked) {
              //       bodyTypes.splice(j, 1)
              //       continue
              //     }
              //   }
              //   // ふたつ以上（配列である）
              //   else {
              //     const len = filter.othersSupportCar.length
              //     let val = ''
              //     for (let l = 0; l < len; l++) {
              //       val = filter.othersSupportCar[l].value
              //       if (bodyType.supportCar != null && !this.inArray(bodyType.supportCar, val) && filter.othersSupportCar[l].checked) {
              //         bodyTypes.splice(j, 1)
              //         continue loopBodyType
              //       }
              //       if (bodyType.supportCar == null && filter.othersSupportCar.checked) {
              //         bodyTypes.splice(j, 1)
              //         continue loopBodyType
              //       }
              //     }
              //   }
              // }
              // 環境性能割 非課税
              if (filter.othersKankyowari != null && filter.othersKankyowari.checked) {
                if (bodyType.kankyowari !== true) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              // 重量税 減税
              if (filter.othersEcoTax != null && filter.othersEcoTax.checked) {
                if (bodyType.weightTaxRate == null || bodyType.weightTaxRate === 0) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
              // グリーンディーゼル補助金
              if (filter.othersSubsidy != null && filter.othersSubsidy.checked) {
                if (bodyType.subsidy !== true) {
                  bodyTypes.splice(j, 1)
                  continue
                }
              }
            }
          }
        }
      }
    }

    // bodyTypesが[]であればmodelを削除する
    if (models && models.length > 0) {
      let i = models.length
      while (i--) {
        const bodyTypes = models[i].bodyTypes
        if (bodyTypes.length === 0) {
          models.splice(i, 1)
        }
      }
    }

    this.setState({
      models: models
    })

    setTimeout(
      this.setNamePlateHeight,
      200
    )
  };

  getFilterValue = (form, name) => {
    let value = null

    if (form[name] == null) {
      return null
    }

    // select
    if (form[name].type === 'select-one') {
      return form[name].value
    }

    // radio
    for (let i = 0; i < form[name].length; i++) {
      if (form[name][i].checked) {
        value = form[name][i].value
        return value
      }
    }

    return value
  };

  onResize = (e) => {
    this.setNamePlateHeight()
  };

  setNamePlateHeight = () => {
    let cars
    let namePlates
    let namePlate
    let namePlatesNum
    const heights = []
    let maxHeight = 0
    let columnNum

    cars = this.refs.cars

    if (!WINDOW || !cars) {
      return false
    }

    columnNum = IS_MOBILE ? 2 : 5

    namePlates = cars.querySelectorAll('.CarLineup__Cars__Body__Item__List__Item--name__title')

    if (!namePlates) {
      return false
    }

    namePlatesNum = namePlates.length

    // 全ネームプレートの高さ取得＆初期化
    for (let i = 0; i < namePlatesNum; i++) {
      namePlate = namePlates[i]
      namePlate.style.height = '' // リサイズイベントに対応するために初期化
      // heights[i] = namePlate.getBoundingClientRect().height;
      heights[i] = namePlate.offsetHeight
    }

    if (this.state.view !== 'Grid') {
      return false
    }

    // 行ごとのネームプレートの高さを最大値に揃える
    for (let i = 0; i < namePlatesNum; i++) {
      if (i % columnNum === 0) {
        maxHeight = 0
      }
      if (heights[i] > maxHeight) {
        maxHeight = heights[i]
      }

      let j = i
      do {
        heights[j] = maxHeight
        if (j % columnNum === 0) {
          break
        }
      } while (j--)
    }

    // ネームプレートの高さをセットする
    for (let i = 0; i < namePlatesNum; i++) {
      namePlate = namePlates[i]
      namePlate.style.height = heights[i] + 'px'
    }

    // console.log(heights)
  };

  hasSpecialVehicle = (carId) => {
    const models = this.props.models

    if (models && Array.isArray(models) && models.length > 0) {
      let i = models.length
      while (i--) {
        const bodyTypes = models[i].bodyTypes
        if (bodyTypes && Array.isArray(bodyTypes) && bodyTypes.length > 0) {
          let j = bodyTypes.length
          while (j--) {
            const bodyType = bodyTypes[j]
            if (bodyType.grades && Array.isArray(bodyType.grades) && bodyType.grades.length > 0) {
              let k = bodyType.grades.length
              while (k--) {
                const grade = bodyType.grades[k]
                if (grade.specialCar === true && bodyType.carId === carId) {
                  return true
                }
              }
            }
          }
        }
      }
    }

    return false
  };

  format = str => convertKataToRome(String(str).toLowerCase().split(' ').join('-'));

  inArray = (array, val) => {
    if (!Array.isArray(array)) {
      return false
    }
    if (array.indexOf(val) >= 0) {
      return true
    }

    return false
  };

  triggerEvent = (element, event) => {
    if (document.createEvent) {
      // IE以外
      const evt = document.createEvent('HTMLEvents')
      evt.initEvent(event, true, true) // event type, bubbling, cancelable
      return !element.dispatchEvent(evt)
    }

    // IE
    const evt = document.createEventObject()
    return element.fireEvent('on' + event, evt)
  };
}

export default CarLineup



// WEBPACK FOOTER //
// ./src/containers/car-lineup/index.jsx